import { useCallback } from "react";
import { Breadcrumbs } from "~/components/UI";
import UserRoles from "./Components/UserRoles";
import { useTranslation } from "react-i18next";

/**
 * @namespace Roles
 */

const Roles = () => {
  const { t } = useTranslation();

  const getBreadcrumbs = useCallback(() => {
    return [{ label: t("title.catalogs") }, { label: t("title.userRoles") }];
  }, [t]);
  return (
    <>
      <Breadcrumbs links={getBreadcrumbs()} />
      <UserRoles />
    </>
  );
};

export default Roles;
